import MYDocumentStatusLog from "./myDocumentStatusLog";


class MYDocumentStatusLogCollection {
  data: Array<MYDocumentStatusLog>;

  constructor(data: Array<MYDocumentStatusLog>) {
    this.data = data;
  }

  length() {
    return this.data.length;
  }
}

export default MYDocumentStatusLogCollection;
